import { SystemPermissions, type SystemPermissionKey } from "@nexus/contracts";
import { useAuth } from "@/features/auth/hooks/useAuth";

/**
 * The non-hook form of `usePermissions` plus `useIsSuperTenant`, for route loaders.
 *
 * A loader that prefetches an endpoint the caller cannot reach turns a missing
 * grant into an uncaught 403 and the generic crash screen, so the prefetch has
 * to ask first. Same rule as the hook, including the super-tenant bypass the
 * API's `requirePermission` applies.
 */
export function hasActionPermission(key: SystemPermissionKey): boolean {
  const { tenants, activeTenantId } = useAuth.getState();
  if (tenants.some((tenant) => tenant.type === "SUPER_TENANT")) return true;

  const activeTenant = tenants.find((tenant) => tenant.id === activeTenantId);
  if (!activeTenant) return false;

  const def = SystemPermissions[key];
  return activeTenant.permissions.some(
    (permission) => permission.method === def.method && permission.route === def.route,
  );
}
